import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { IMAGES } from "@/lib/constants";

const EASE = [0.16, 1, 0.3, 1];

const WORKS = [
  { src: IMAGES.installation, title: "Instalação residencial", city: "Ilhéus — BA", span: "lg:row-span-2" },
  { src: IMAGES.panelsCloseUp, title: "Sistema fotovoltaico", city: "Itabuna — BA", span: "" },
  { src: IMAGES.commercial, title: "Projeto comercial", city: "Jequié — BA", span: "" },
  { src: IMAGES.modernHome, title: "Residência de alto padrão", city: "Barra Grande — BA", span: "lg:row-span-2" },
  { src: IMAGES.hero, title: "Telhado com geração solar", city: "Teixeira de Freitas — BA", span: "" },
];

export const Galeria = () => (
  <section
    id="projetos"
    data-testid="gallery-section"
    className="relative py-24 lg:py-32 bg-white border-t border-slate-100"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="max-w-3xl"
      >
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-amber-500 mb-4">
          Galeria de obras
        </p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight text-[#0B192C]">
          Energia solar instalada{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-500 to-amber-600">
            pela nossa equipe
          </span>
        </h2>
      </motion.div>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 auto-rows-[240px] gap-5">
        {WORKS.map((w, i) => (
          <motion.figure
            key={w.title}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: (i % 3) * 0.1, ease: EASE }}
            className={`group relative overflow-hidden rounded-3xl border border-slate-200/70 ${w.span}`}
          >
            <img
              src={w.src}
              alt={`${w.title} em ${w.city}`}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B192C]/85 via-transparent to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-500" />
            <figcaption className="absolute bottom-0 inset-x-0 p-5 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
              <p className="font-display font-bold text-white">{w.title}</p>
              <p className="flex items-center gap-1.5 text-xs font-semibold text-amber-300 mt-1">
                <MapPin className="h-3.5 w-3.5" />
                {w.city}
              </p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
